module.exports = __webpack_public_path__ + "static/login-14ba749c1517158a2c2dc22417974472.svg";